import {http} from './config/config-relation-register'
export default{    
    salvar:(token, ingrediente)=>{
        return http.post('cad-ingrediente-ativos', ingrediente,{
            headers:{
                'Authorization':token
            }
        })
    }, 
    atualizar:(token, ingrediente)=>{
        return http.put(`cad-ingrediente-ativos/${ingrediente.id_cad_ingrediente_Ativo}`,ingrediente,{
            headers:{
                'Authorization':token
            }
        })
    },
    findByProduto:(token, id)=>{
        return http.get(`cad-ingrediente-ativos/produto/${id}`,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, id)=>{
        return http.delete(`cad-ingrediente-ativos/${id}`,{
            headers:{
                'Authorization':token
            }
        })
    },
}